import { createSelector } from 'reselect';

const getEvents = state => state.event;
const getMainEvent = state => Object.values(state.event.events)[0];

export const getPriceLevels = createSelector(
    [getMainEvent],
    (event) => {
        let levels = {};
        event.price_levels.map(pl => {
            levels[pl.price_level_id] = pl;
        });
        return levels;
    }
)

export const getProducts = createSelector(
    [getMainEvent],
    (event) => {
        let products = {};
        event.products.map(product => {
            products[product.product_id] = product;
        });
        return products;
    }
)

export const getBundles = createSelector(
    [getMainEvent],
    (event) => {
        let bundles = {};
        event.bundles.map(bn => {
            bundles[bn.id] = bn;
        });
        return bundles;
    }
)

export const hasCoupons = createSelector([getEvents],(events) =>  {
    let hasCoupons = false;
    if(events.childEvent && events.childEvent.event.hasCoupons) {
        hasCoupons = true;
    }

    if(!hasCoupons && events && events.events) {
        hasCoupons = Object.values(events.events)[0].event.hasCoupons;
    }

    return hasCoupons;
});
